import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import HLabel from "@cloudpivot/form/src/common/components/label.vue";
let DescriptionDesign = class DescriptionDesign extends Vue {
    render(h) {
        return h('h-label', { props: { control: this.control
            } });
    }
};
tslib_1.__decorate([
    Prop()
], DescriptionDesign.prototype, "control", void 0);
DescriptionDesign = tslib_1.__decorate([
    Component({
        name: 'DescriptionDesign',
        components: {
            HLabel: HLabel
        }
    })
], DescriptionDesign);
export default DescriptionDesign;
